import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default function DeleteUserDialog({
  openState,
  userContext,
  onClose,
  onDeleteUser,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (openState) {
      setSubmitting(false);
      setError("");
    }
  }, [openState, userContext?.userId]);

  if (!("row" in userContext)) {
    return <></>;
  }

  const displayName =
    userContext.row.nickname || userContext.row.name || userContext.row.email || userContext.row.userId;

  const handleSubmit = async () => {
    setSubmitting(true);
    setError("");

    const result = await onDeleteUser(userContext.row.userId);
    if (result?.ok) {
      onClose();
      return;
    }

    setError(result?.error || "Failed to delete user");
    setSubmitting(false);
  };

  return (
    <Dialog
      open={openState}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="delete-user-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="delete-user-dialog-title">
        Delete {displayName}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete <strong>{displayName}</strong>? This
          will remove the user account and run the same erasure flow used for
          approved deletion requests.
        </DialogContentText>
        <DialogContentText>
          Related private records may be deleted or anonymized. This action
          cannot be undone from the admin.
        </DialogContentText>
        {error ? (
          <Typography variant="body2" style={{ marginTop: 12, color: "#d32f2f" }}>
            {error}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          {submitting ? "Deleting..." : "Delete User"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
